require('!!raw-loader!/builds/1075789/v2/src/purchase.html');